import {publishTrackEvent} from "../.."

const TrackFacetDeselection = (facetCategory: string, facetOption: string) => {
    publishTrackEvent("facet", {
        facet: {
            category: "facet",
            action: "remove",
            label: facetCategory,
            option: facetOption,
        },
    })
}

export default TrackFacetDeselection
